import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useSetAtom } from 'jotai';
import { useOperatorMenuVisibility } from '@ibk/shared-permissioning';
import { TranslationProvider, useTranslation } from '@ibk/shared-translation';
import { operatorDrawerAtom } from '@ibk/shared-utils';
import { sharedUiTranslations } from '../../translations';
import ProfileMenuItem from '../ProfileMenuItem';
export const ProfileMenuOperatorItemBase = () => {
    const { t } = useTranslation();
    const canSeeOperator = useOperatorMenuVisibility();
    const setOperatorDrawerVisible = useSetAtom(operatorDrawerAtom);
    return (_jsx(ProfileMenuItem, { isVisible: canSeeOperator, title: t('profile-menu-item.operators'), onClick: () => {
            setOperatorDrawerVisible(true);
        } }));
};
export const ProfileMenuOperatorItem = () => {
    return (_jsx(TranslationProvider, { translations: sharedUiTranslations, defaultLanguage: 'pt-BR', children: _jsx(ProfileMenuOperatorItemBase, {}) }));
};
export default ProfileMenuOperatorItem;
